/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Call { 
    sessionId?: number;
    serviceNumber?: string;
    componentId?: number;
    state?: number;
    creationTime?: Date;
    fullNumber?: string;
    callingNumber?: string;
    genericNumber?: string;
    dialledNumber?: string;
    redirectingNumber?: string;
    originallyCalledNumber?: string;
    answeringNumber?: string;
    clir?: boolean;
    prioritized?: boolean;
    suspect?: boolean;
    organization?: string;
    departmentId?: number;
    fromAgentOrganization?: string;
    fromCid?: number;
    fromAgentLogin?: string;
    agentOrganization?: string;
    agentLogin?: string;
    agentMessage?: string;
    agentDisplayMode?: number;
    transferState?: number;
    type?: number;
    triggerPoint?: number;
    serviceIndicator?: number;
    callingNumberIndicator?: number;
    direction?: Call.DirectionEnum;
}
export namespace Call {
    export type DirectionEnum = 'INBOUND' | 'OUTBOUND';
    export const DirectionEnum = {
        INBOUND: 'INBOUND' as DirectionEnum,
        OUTBOUND: 'OUTBOUND' as DirectionEnum
    };
}
